const formatAmount = (value?: number) =>
  value
    ? Number(value).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "0.00";
export { formatAmount };
